/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ResponseBoolean,
  ResponseListLong,
  ResponseListWarehouseNationGroupResVo,
  ResponseListWarehouseResVo,
  ResponsePageDataWarehouseResVo,
  ResponseWarehouseResVo,
  WarehouseAddReqVo,
  WarehouseDelReqVo,
  WarehouseSortReqVo,
  WarehouseUpdateReqVo,
} from '../models/index';
import {
    ResponseBooleanFromJSON,
    ResponseBooleanToJSON,
    ResponseListLongFromJSON,
    ResponseListLongToJSON,
    ResponseListWarehouseNationGroupResVoFromJSON,
    ResponseListWarehouseNationGroupResVoToJSON,
    ResponseListWarehouseResVoFromJSON,
    ResponseListWarehouseResVoToJSON,
    ResponsePageDataWarehouseResVoFromJSON,
    ResponsePageDataWarehouseResVoToJSON,
    ResponseWarehouseResVoFromJSON,
    ResponseWarehouseResVoToJSON,
    WarehouseAddReqVoFromJSON,
    WarehouseAddReqVoToJSON,
    WarehouseDelReqVoFromJSON,
    WarehouseDelReqVoToJSON,
    WarehouseSortReqVoFromJSON,
    WarehouseSortReqVoToJSON,
    WarehouseUpdateReqVoFromJSON,
    WarehouseUpdateReqVoToJSON,
} from '../models/index';

export interface WarehouseDeleteRequest {
    warehouseDelReqVo?: WarehouseDelReqVo;
}

export interface WarehouseGetRequest {
    currentPage?: number;
    pageSize?: number;
    id?: number;
    name?: string;
    code?: string;
    nationId?: number;
    warehouseType?: number;
    enable?: number;
}

export interface WarehouseIdGetRequest {
    id: number;
}

export interface WarehouseIdPutRequest {
    id: number;
    warehouseUpdateReqVo?: WarehouseUpdateReqVo;
}

export interface WarehouseIdStatusPatchRequest {
    id: number;
    enable: number;
}

export interface WarehousePostRequest {
    warehouseAddReqVo?: WarehouseAddReqVo;
}

export interface WarehouseSortPutRequest {
    warehouseSortReqVo?: WarehouseSortReqVo;
}

/**
 * 
 */
export class WarehouseControllerApi extends runtime.BaseAPI {

    /**
     * 仓库管理·列表查询（不分页）
     * 仓库管理·列表查询（不分页）
     */
    async warehouseAllGetRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseListWarehouseResVo>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/warehouse/all`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseListWarehouseResVoFromJSON(jsonValue));
    }

    /**
     * 仓库管理·列表查询（不分页）
     * 仓库管理·列表查询（不分页）
     */
    async warehouseAllGet(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseListWarehouseResVo> {
        const response = await this.warehouseAllGetRaw(initOverrides);
        return await response.value();
    }

    /**
     * 仓库管理·批量删除
     * 仓库管理·批量删除
     */
    async warehouseDeleteRaw(requestParameters: WarehouseDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseListLong>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/warehouse`,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
            body: WarehouseDelReqVoToJSON(requestParameters['warehouseDelReqVo']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseListLongFromJSON(jsonValue));
    }

    /**
     * 仓库管理·批量删除
     * 仓库管理·批量删除
     */
    async warehouseDelete(requestParameters: WarehouseDeleteRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseListLong> {
        const response = await this.warehouseDeleteRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 仓库管理·分页列表查询
     * 仓库管理·分页列表查询
     */
    async warehouseGetRaw(requestParameters: WarehouseGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponsePageDataWarehouseResVo>> {
        const queryParameters: any = {};

        if (requestParameters['currentPage'] != null) {
            queryParameters['currentPage'] = requestParameters['currentPage'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }

        if (requestParameters['id'] != null) {
            queryParameters['id'] = requestParameters['id'];
        }

        if (requestParameters['name'] != null) {
            queryParameters['name'] = requestParameters['name'];
        }

        if (requestParameters['code'] != null) {
            queryParameters['code'] = requestParameters['code'];
        }

        if (requestParameters['nationId'] != null) {
            queryParameters['nationId'] = requestParameters['nationId'];
        }

        if (requestParameters['warehouseType'] != null) {
            queryParameters['warehouseType'] = requestParameters['warehouseType'];
        }

        if (requestParameters['enable'] != null) {
            queryParameters['enable'] = requestParameters['enable'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/warehouse`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponsePageDataWarehouseResVoFromJSON(jsonValue));
    }

    /**
     * 仓库管理·分页列表查询
     * 仓库管理·分页列表查询
     */
    async warehouseGet(requestParameters: WarehouseGetRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponsePageDataWarehouseResVo> {
        const response = await this.warehouseGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 仓库管理·按国家分组
     * 仓库管理·按国家分组
     */
    async warehouseGroupByNationGetRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseListWarehouseNationGroupResVo>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/warehouse/group-by-nation`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseListWarehouseNationGroupResVoFromJSON(jsonValue));
    }

    /**
     * 仓库管理·按国家分组
     * 仓库管理·按国家分组
     */
    async warehouseGroupByNationGet(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseListWarehouseNationGroupResVo> {
        const response = await this.warehouseGroupByNationGetRaw(initOverrides);
        return await response.value();
    }

    /**
     * 仓库管理·详情查询
     * 仓库管理·详情查询
     */
    async warehouseIdGetRaw(requestParameters: WarehouseIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseWarehouseResVo>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling warehouseIdGet().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/warehouse/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseWarehouseResVoFromJSON(jsonValue));
    }

    /**
     * 仓库管理·详情查询
     * 仓库管理·详情查询
     */
    async warehouseIdGet(requestParameters: WarehouseIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseWarehouseResVo> {
        const response = await this.warehouseIdGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 仓库管理·更新仓库
     * 仓库管理·更新仓库
     */
    async warehouseIdPutRaw(requestParameters: WarehouseIdPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseWarehouseResVo>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling warehouseIdPut().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/warehouse/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: WarehouseUpdateReqVoToJSON(requestParameters['warehouseUpdateReqVo']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseWarehouseResVoFromJSON(jsonValue));
    }

    /**
     * 仓库管理·更新仓库
     * 仓库管理·更新仓库
     */
    async warehouseIdPut(requestParameters: WarehouseIdPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseWarehouseResVo> {
        const response = await this.warehouseIdPutRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 仓库管理·修改状态
     * 仓库管理·修改状态
     */
    async warehouseIdStatusPatchRaw(requestParameters: WarehouseIdStatusPatchRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseWarehouseResVo>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling warehouseIdStatusPatch().'
            );
        }

        if (requestParameters['enable'] == null) {
            throw new runtime.RequiredError(
                'enable',
                'Required parameter "enable" was null or undefined when calling warehouseIdStatusPatch().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['enable'] != null) {
            queryParameters['enable'] = requestParameters['enable'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/warehouse/{id}/status`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseWarehouseResVoFromJSON(jsonValue));
    }

    /**
     * 仓库管理·修改状态
     * 仓库管理·修改状态
     */
    async warehouseIdStatusPatch(requestParameters: WarehouseIdStatusPatchRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseWarehouseResVo> {
        const response = await this.warehouseIdStatusPatchRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 仓库管理·新增仓库
     * 仓库管理·新增仓库
     */
    async warehousePostRaw(requestParameters: WarehousePostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseWarehouseResVo>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/warehouse`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: WarehouseAddReqVoToJSON(requestParameters['warehouseAddReqVo']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseWarehouseResVoFromJSON(jsonValue));
    }

    /**
     * 仓库管理·新增仓库
     * 仓库管理·新增仓库
     */
    async warehousePost(requestParameters: WarehousePostRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseWarehouseResVo> {
        const response = await this.warehousePostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 仓库管理·仓库排序
     * 仓库管理·仓库排序
     */
    async warehouseSortPutRaw(requestParameters: WarehouseSortPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseBoolean>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/warehouse/sort`,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: WarehouseSortReqVoToJSON(requestParameters['warehouseSortReqVo']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseBooleanFromJSON(jsonValue));
    }

    /**
     * 仓库管理·仓库排序
     * 仓库管理·仓库排序
     */
    async warehouseSortPut(requestParameters: WarehouseSortPutRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseBoolean> {
        const response = await this.warehouseSortPutRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
